import DOMPurify from "dompurify";

const sanitizedTags = {
  ALLOWED_TAGS: ["b", "i", "em", "strong", "a", "hl", "br"],
  ALLOWED_ATTR: ["href", "class", "target"],
};

export const sanitizeHTML = (
  html: HTMLElement | string,
  options?: { ALLOWED_TAGS: string[]; ALLOWED_ATTR: string[] }
): { __html: string } => ({
  __html: DOMPurify.sanitize(html, { ...sanitizedTags, ...options }),
});

export const sanitizeString = (
  value: string,
  options?: { ALLOWED_TAGS: string[]; ALLOWED_ATTR: string[] }
): string => DOMPurify.sanitize(value, { ...sanitizedTags, ...options });
